
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { map } from 'rxjs/operators';
import {AccountService} from "../../services";
import {environment} from "../../../../environments/environment";
import {ServiceUseReportItems} from "../models/serviceUseReportItems";

@Injectable({ providedIn: 'root' })
export class ServiceUseReportService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    get(createdAt: string, createdAtTo: string, worker: string) {
        return this.http.post(`${environment.apiEndpoint}/v1/reports/service-use`, {
            'createdAt': createdAt,
            'createdAtTo': createdAtTo,
            'worker': worker
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: ServiceUseReportItems) => {
                return x;
            }));
    }
}
